// extracted by mini-css-extract-plugin
export default {"clockWrapper":"DigitalClock_clockWrapper__JGdbI","clockText":"DigitalClock_clockText__UFiQD"};